import { render } from "./notification.vue?vue&type=template&id=ff849ca4"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"

import "./notification.vue?vue&type=style&index=0&id=ff849ca4&lang=css"
script.render = render

export default script